import { useMediaProps } from '@zapier/responsive-utils';
import { useEffect, useState } from 'react';
import { mediaQueryValues } from '../constants';

type SizeType = 'mobile' | 'tablet' | 'desktop';

/**
 * @deprecated
 * Please use useViewportSize for correct mediaQuery sizes.
 */
export const useScreenSize = () => {
  const [{ size, isKnown }, setSize] = useState<{
    size: SizeType;
    isKnown: boolean;
  }>({
    size: 'mobile',
    /**
     * We don't initially know the screen size and may want to hold off
     * rendering a component until we know it and are not just using the default 'mobile' size.
     */
    isKnown: false,
  });

  const mediaPropsSize = useMediaProps({
    all: {
      size: 'mobile',
    },
    [mediaQueryValues.tablet]: { size: 'tablet' },
    [mediaQueryValues.desktop]: { size: 'desktop' },
  }).size;

  useEffect(() => {
    setSize({ size: mediaPropsSize, isKnown: true });
  }, [mediaPropsSize]);

  return {
    isKnown,
    isMobile: size === 'mobile',
    isTablet: size === 'tablet',
    isDesktop: size === 'desktop',
    size,
  };
};
